import React, { useState } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./NewBar.css";
import Logo from "../Images/logo.png";
import LogoWhite from "../Images/logo-white.png";
import { ArrowUpRight, Menu, X } from "lucide-react";

function UbunifuNavbar() {
  const [hoveredDropdown, setHoveredDropdown] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => {
    setMenuOpen(false);
    setExpandedMenu(null);
  };

  const toggleSubmenu = (menu) => {
    setExpandedMenu(expandedMenu === menu ? null : menu);
  };

  return (
    <>
      <Navbar expand="lg" className="ubunifu-navbar py-3" sticky="top">
        <Container fluid className="nav-container">
          <div className="nav-left">
            <Navbar.Brand href="/">
              <img src={Logo} alt="Ubunifu Logo" height="46" />
            </Navbar.Brand>
          </div>

          <Navbar.Collapse
            id="basic-navbar-nav"
            className="nav-center justify-content-center"
          >
            <Nav className="align-items-center">
              <Nav.Link href="https://research.ubunifucollege.com/" className="nav-link-custom new-nav-link">
                Home
              </Nav.Link>

              <NavDropdown
                title="Explore"
                id="explore-dropdown"
                show={hoveredDropdown === "explore"}
                onMouseEnter={() => setHoveredDropdown("explore")}
                onMouseLeave={() => setHoveredDropdown(null)}
                className="nav-link-custom"
              >
                <NavDropdown.Item href="https://research.ubunifucollege.com/about">
                  About Us
                </NavDropdown.Item>
                <NavDropdown.Item href="https://app.ubunifucollege.com/">
                  Developer Login
                </NavDropdown.Item>
                <NavDropdown.Item href="https://app.ubunifucollege.com/">
                  Client Login
                </NavDropdown.Item>
                <NavDropdown.Item href="https://research.ubunifucollege.com/contact">
                  Contact Us
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                title="What we do"
                id="whatwedo-dropdown"
                show={hoveredDropdown === "whatwedo"}
                onMouseEnter={() => setHoveredDropdown("whatwedo")}
                onMouseLeave={() => setHoveredDropdown(null)}
                className="nav-link-custom"
              >
                <NavDropdown.Item href="https://research.ubunifucollege.com/managed-product">
                  Managed Product
                </NavDropdown.Item>
                <NavDropdown.Item href="https://research.ubunifucollege.com/managed-service">
                  Managed Service
                </NavDropdown.Item>
                <NavDropdown.Item href="https://research.ubunifucollege.com/extended-teams">
                  Extended Team
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                title="Research"
                id="research-dropdown"
                show={hoveredDropdown === "research"}
                onMouseEnter={() => setHoveredDropdown("research")}
                onMouseLeave={() => setHoveredDropdown(null)}
                className="nav-link-custom"
              >
                <NavDropdown.Item href="https://research.ubunifucollege.com/white-papers">
                  White Papers
                </NavDropdown.Item>
                <NavDropdown.Item href="https://research.ubunifucollege.com/focus-area">
                  Focus Area
                </NavDropdown.Item>
                <NavDropdown.Item href="https://research.ubunifucollege.com/products">
                  Products
                </NavDropdown.Item>
                <NavDropdown.Item href="https://research.ubunifucollege.com/startups">
                  Startups We’ve Built
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                href="https://ubunifu.credit/"
                className="nav-link-custom new-nav-link"
              >
                Ubunifu Credit
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>

          <div className="nav-right">
            <div className="get-started-btn d-none d-lg-flex">
              <button className="main-btn">GET STARTED</button>
              <div className="circle-btn">
                <ArrowUpRight size={20} color="white" />
              </div>
            </div>

            <div className="toggle-custom d-lg-none" onClick={toggleMenu}>
              {menuOpen ? <X size={30} color="#000" /> : <Menu size={30} color="#000" />}
            </div>
          </div>
        </Container>
      </Navbar>

      {/* Fullscreen Mobile Menu */}
      <div className={`mobile-menu-overlay ${menuOpen ? "show" : ""}`}>
        <div className="mobile-menu-header">
          <img src={LogoWhite} alt="Ubunifu Logo" height="36" />
          <X size={30} color="#fff" className="close-btn" onClick={closeMenu} />
        </div>

        <div className="mobile-menu-content">
          <a href="https://research.ubunifucollege.com/" onClick={closeMenu}>
            Home
          </a>

          <div className="mobile-submenu">
            <div
              className="submenu-title"
              onClick={() => toggleSubmenu("explore")}
            >
              Explore
            </div>
            {expandedMenu === "explore" && (
              <div className="submenu-items">
                <a href="https://research.ubunifucollege.com/about" onClick={closeMenu}>
                  About Us
                </a>
                <a href="https://app.ubunifucollege.com/" onClick={closeMenu}>
                  Developer Login
                </a>
                <a href="https://app.ubunifucollege.com/" onClick={closeMenu}>
                  Client Login
                </a>
                <a href="https://research.ubunifucollege.com/contact" onClick={closeMenu}>
                  Contact Us
                </a>
              </div>
            )}
          </div>

          <div className="mobile-submenu">
            <div
              className="submenu-title"
              onClick={() => toggleSubmenu("whatwedo")}
            >
              What We Do
            </div>
            {expandedMenu === "whatwedo" && (
              <div className="submenu-items">
                <a href="https://research.ubunifucollege.com/managed-product" onClick={closeMenu}>
                  Managed Product
                </a>
                <a href="https://research.ubunifucollege.com/managed-service" onClick={closeMenu}>
                  Managed Service
                </a>
                <a href="https://research.ubunifucollege.com/extended-teams" onClick={closeMenu}>
                  Extended Team
                </a>
              </div>
            )}
          </div>

          <div className="mobile-submenu">
            <div
              className="submenu-title"
              onClick={() => toggleSubmenu("research")}
            >
              Research
            </div>
            {expandedMenu === "research" && (
              <div className="submenu-items">
                <a href="https://research.ubunifucollege.com/white-papers" onClick={closeMenu}>
                  White Papers
                </a>
                <a href="https://research.ubunifucollege.com/focus-area" onClick={closeMenu}>
                  Focus Area
                </a>
                <a href="https://research.ubunifucollege.com/products" onClick={closeMenu}>
                  Products
                </a>
                <a href="https://research.ubunifucollege.com/startups" onClick={closeMenu}>
                  Startups We’ve Built
                </a>
              </div>
            )}
          </div>

          <a href="https://ubunifu.credit/" onClick={closeMenu}>
            Ubunifu Credit
          </a>

          <div className="get-started-btn mobile-btn" onClick={closeMenu}>
            <button className="main-btn">GET STARTED</button>
            <div className="circle-btn">
              <ArrowUpRight size={20} color="white" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UbunifuNavbar;